import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { menuItems } from '../../constants/JsonObjects';
import { useNavigate } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse } from '@mui/material';
import { useGetBrands } from '../../hooks/useGetBrands';
import { HeaderQueryParams } from '../header/Header';
import Logo from '../UI/logo';

const SidebarDrawer = ({open,setOpen,brands}:any)=> {
  
const navigate = useNavigate()
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const [dropdownOpen, setDropDownOpen] = React.useState(false);
  const handleClick = () => {
    setDropDownOpen(!dropdownOpen);
  };

  const handleBrandSelection = (selectedBrand:string) =>{
    const params: HeaderQueryParams = {
      selectedBrand: selectedBrand
    };
      const queryString = new URLSearchParams(params as any).toString();
      navigate(`/models?${queryString}`);
  }


  const DrawerList = (
    <Box sx={{ width: 250}} role="presentation" >
       <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  minWidth: 100,
                  // bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                
                
                {menuItems.map((page: any, index: any) =>
                  page.name !== "shop" ? (
                    <ListItemButton
                    sx={{borderBottom:'1px solid #ccc'}}
                    key={index}
                      onClick={() => {
                        // if (page.name === "Logout") {
                        //   removeAuthToken();
                        // }
                        setOpen(false);
                        navigate(page.url);

                      }}
                    >
                      <ListItemText primary={page.name} />
                    </ListItemButton>
                  ) : (
                    <React.Fragment key={index}>
                      <ListItemButton onClick={handleClick} sx={{borderBottom:'1px solid #ccc'}}>
                        <ListItemText primary={page.label} />
                        {dropdownOpen ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                      <Collapse in={dropdownOpen} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          {brands?.map((brand:any, index:number) => {
                            return (
                              <ListItemButton key={index} sx={{ pl: 4 }} onClick={()=>{handleBrandSelection(brand.Code);setOpen(false)}}>
                                <ListItemText primary={brand.Code} />
                              </ListItemButton>
                            );
                          })}
                        </List>
                      </Collapse>
                    </React.Fragment>
                  )
                  // <MenuItem key={page.id} onClick={() => {
                  //   if (page.name === "Logout") {
                  //     removeAuthToken();
                  //   }
                  //   handleCloseNavMenu();
                  //   navigate(page.url);
                  // }}>
                  //   <Typography textAlign="center">{page.name}</Typography>
                  // </MenuItem>
                )}
              </List>
    </Box>
  );

  return (
    <div>
      <Drawer anchor="right"  open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
export default SidebarDrawer;